"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimeColumn = exports.DateTimeRangeColumn = void 0;

var _react = _interopRequireDefault(require("react"));

var _DateHelper = require("@civicplus/preamble/lib/Utilities/DateHelper");

var DateTimeRangeColumn = function DateTimeRangeColumn(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      allDay = _ref.allDay,
      timeZone = _ref.timeZone,
      _ref$includeTime = _ref.includeTime,
      includeTime = _ref$includeTime === void 0 ? true : _ref$includeTime;

  if (allDay) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _DateHelper.toDateTimeZone)(startDate, timeZone, true), " All Day - ", (0, _DateHelper.toDateTimeZone)(endDate, timeZone, true), " All Day");
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _DateHelper.toDateTimeZone)(startDate, timeZone, !includeTime), " - ", (0, _DateHelper.toDateTimeZone)(endDate, timeZone, !includeTime));
};

exports.DateTimeRangeColumn = DateTimeRangeColumn;

var DateTimeColumn = function DateTimeColumn(_ref2) {
  var date = _ref2.date,
      timeZone = _ref2.timeZone,
      _ref2$includeTime = _ref2.includeTime,
      includeTime = _ref2$includeTime === void 0 ? true : _ref2$includeTime;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _DateHelper.toDateTimeZone)(date, timeZone, !includeTime));
};

exports.DateTimeColumn = DateTimeColumn;